//FETCH ASSIGNMENTS

export const FETCH_ASSIGNMENTS_REQUEST = "FETCH_ASSIGNMENTS_REQUEST";
export const FETCH_ASSIGNMENTS_SUCCESS = "FETCH_ASSIGNMENTS_SUCCESS";
export const FETCH_ASSIGNMENTS_FAILURE = "FETCH_ASSIGNMENTS_FAILURE";

//DELETE ASSIGNMENTS

export const DELETE_ASSIGNMENT_REQUEST='DELETE_ASSIGNMENT_REQUEST';
export const DELETE_ASSIGNMENT_SUCCESS='DELETE_ASSIGNMENT_SUCCESS';
export const DELETE_ASSIGNMENT_FAILURE='DELETE ASSIGNMENT FAILURE';


//FETCH ASSIGNMENT DETAILS

export const FETCH_ASSIGNMENT_DETAILS_REQUEST = "FETCH_ASSIGNMENT_DETAILS_REQUEST";
export const FETCH_ASSIGNMENT_DETAILS_SUCCESS = "FETCH_ASSIGNMENT_DETAILS_SUCCESS";
export const FETCH_ASSIGNMENT_DETAILS_FAILURE = "FETCH_ASSIGNMENT_DETAILS_FAILURE";